exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mainCard {\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  border-radius: 5px;\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.05);\n}\n.mainCard__loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n.mainCard__header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 16px;\n}\n.mainCard__title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #38373B;\n  text-align: left;\n  direction: ltr;\n}", ""]);

// exports
